module.exports = __webpack_public_path__ + "static/img/loader.0395a07.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.gif
// module id = AcTw
// module chunks = 1